import styled from 'styled-components';

const Container = styled.div`
  margin-bottom: 32px;
  padding: 0 16px;
  width: 100%;
  color: var(--white);
  font-weight: 500;
  font-size: 22px;
  line-height: 1.54;
  span {
    position: relative;
    display: inline-block;
    &:last-child {
      font-weight: 700;
      font-size: 32px;
    }
    &::before {
      content: '';
      position: absolute;
      left: 0;
      bottom: 4px;
      width: 100%;
      height: 16px;
      background: var(--medium-main);
      mix-blend-mode: multiply;
      opacity: 0.4;
      border-radius: 3px;
    }
  }
`;

export { Container };
